/* eslint-disable @typescript-eslint/unbound-method */
import { getServerPageWebConfigByPathHost } from '@ts/operations-ssr'
import { merge } from 'lodash'
import { GetStaticPaths, GetStaticPathsResult, GetStaticProps, GetStaticPropsResult } from 'next'
import React from 'react'

import AnalyticsProvider from '../lib/analytics/AnalyticsProvider'
import { addApolloState, ApolloClient, initializeApollo } from '../lib/apolloClient'
import { ServerProps } from '../lib/server'
import { getWebPageConfigByPathHostVariables, SiteConfigProvider } from '../lib/siteconfig'
import ThemeProvider from '../lib/theming/ThemeProvider'
import AttributionParamsProvider from '../lib/tracking/attribution'

const ConfiguredPageProvider = ({
  children,
  withTracking,
  eventSlug,
  path,
}: {
  children: React.ReactNode
  eventSlug?: string
  path?: string
  withTracking: boolean
}) => {
  let result = children

  if (withTracking) {
    result = (
      <AttributionParamsProvider>
        <AnalyticsProvider>{result}</AnalyticsProvider>
      </AttributionParamsProvider>
    )
  }

  return (
    <SiteConfigProvider eventSlug={eventSlug} path={path}>
      <ThemeProvider>{result}</ThemeProvider>
    </SiteConfigProvider>
  )
}
export default ConfiguredPageProvider

export const configuredPageStaticQueries = async (
  apolloClient: ApolloClient,
  path?: string,
  eventSlug?: string
) => {
  const {
    props: { data: webPageConfig },
  } = await getServerPageWebConfigByPathHost(
    { variables: getWebPageConfigByPathHostVariables(path, eventSlug) },
    apolloClient
  )

  return { webPageConfig }
}

export const defaultConfiguredPageStaticPropsFor: (
  options: Partial<GetStaticPropsResult<ServerProps>>
) => GetStaticProps = (options = {}) => async () => {
  const apolloClient = initializeApollo()
  await configuredPageStaticQueries(apolloClient)
  return addApolloState(apolloClient, merge({ props: {}, revalidate: 3600 }, options))
}

export const defaultConfiguredPageStaticPathsFor: (
  ...defaultPaths: GetStaticPathsResult['paths']
) => GetStaticPaths = (...defaultPaths) => async () =>
  Promise.resolve({
    fallback: true,
    paths: defaultPaths,
  })
